import { ChatDetailsResponse } from '@choco-admin/types';
import { Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';

import { ErrorCard } from '../../../../../../components/ErrorCard';
import { PageLoading } from '../../../../../../components/PageLoading';
import { useChatHistoryData } from '../../../../hooks';
import { PageHeader } from '../PageHeader';

import { ChatHistoryList } from './history/ChatHistoryList';

interface ChatHistoryTabPanelProps {
  chatData: ChatDetailsResponse;
  chatId: string;
}

export const ChatHistoryTabPanel: React.FC<ChatHistoryTabPanelProps> = ({
  chatData,
  chatId,
}) => {
  const { historyData, isLoading, error, refetch } = useChatHistoryData(chatId);

  if (isLoading) {
    return <PageLoading text="Loading chat history..." />;
  }

  if (error) {
    return (
      <ErrorCard
        title="Failed to Load Chat History"
        message={error.message}
        action={{
          label: 'Try Again',
          onPress: refetch,
        }}
      />
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardBody className="space-y-8">
          <PageHeader
            title="Chat History"
            subtitle="View messages and order history for this chat."
            icon={<FiMessageSquare className="w-6 h-6 text-success" />}
          />

          {historyData && historyData.messages.length > 0 ? (
            <ChatHistoryList messages={historyData.messages} />
          ) : (
            <p className="text-foreground-500 text-center py-8">
              No chat history available.
            </p>
          )}
        </CardBody>
      </Card>
    </div>
  );
};
